var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("drawer", {
        ref: "filterDrawer",
        scopedSlots: _vm._u([
          {
            key: "defult",
            fn: function () {
              return [
                _c(
                  "el-form-item",
                  { attrs: { label: "用户来源:" } },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.listQuery.search_user_type,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "search_user_type", $$v)
                          },
                          expression: "listQuery.search_user_type",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "全部", value: "2" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "微信", value: "0" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "支付宝", value: "1" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "用户ID:" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_uid,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_uid", $$v)
                        },
                        expression: "form.search_uid",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-sm-and-down",
                    attrs: { label: "用户昵称:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_nick_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_nick_name", $$v)
                        },
                        expression: "form.search_nick_name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-lg-and-down",
                    attrs: { label: "手机号码:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_phone", $$v)
                        },
                        expression: "form.search_phone",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-lg-and-down",
                    attrs: { label: "OpenId:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_openid,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_openid", $$v)
                        },
                        expression: "form.search_openid",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                      },
                      [
                        _vm._v("查询"),
                        _c("i", {
                          staticClass: "el-icon-search el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "warning", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.toQuery(1)
                          },
                        },
                      },
                      [
                        _vm._v("重置"),
                        _c("i", {
                          staticClass: "el-icon-refresh el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.checkRoles(["partner"])
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.$router.push({
                                  path: "/userManage/portrait",
                                })
                              },
                            },
                          },
                          [_vm._v("用户画像")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "more",
            fn: function () {
              return [
                _vm.checkRoles(["terminal"])
                  ? _c("sel-plat", {
                      attrs: { listQuery: _vm.listQuery },
                      on: {
                        change: function ($event) {
                          return _vm.toQuery()
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-md-and-up",
                    attrs: { label: "用户昵称:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_nick_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_nick_name", $$v)
                        },
                        expression: "form.search_nick_name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-xg-and-up",
                    attrs: { label: "手机号码:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_phone", $$v)
                        },
                        expression: "form.search_phone",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-form-item", { attrs: { label: "最后登录:" } }, [
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "开始日期",
                          "value-format": "timestamp",
                          "picker-options": _vm.beginOptions,
                        },
                        model: {
                          value: _vm.form.begin,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "begin", $$v)
                          },
                          expression: "form.begin",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-5 mr-5" }, [_vm._v("-")]),
                      _vm._v(" "),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "结束日期",
                          "value-format": "timestamp",
                          "picker-options": _vm.endOptions,
                        },
                        model: {
                          value: _vm.form.end,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "end", $$v)
                          },
                          expression: "form.end",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "充电桩用户:" } },
                  [
                    _c(
                      "el-select",
                      {
                        model: {
                          value: _vm.form.is_zhuang_maxw,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "is_zhuang_maxw", $$v)
                          },
                          expression: "form.is_zhuang_maxw",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "全部", value: "0" },
                        }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "是", value: "1" } }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "否", value: "2" } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-xg-and-up",
                    attrs: { label: "OpenId:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_openid,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_openid", $$v)
                        },
                        expression: "form.search_openid",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("div", { staticClass: "p-5" }, [
        _c(
          "div",
          { staticClass: "bg-white" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                ref: "order_table",
                staticClass: "ptd-5",
                attrs: {
                  id: "order_table",
                  data: _vm.list,
                  "max-height": _vm.tableMaxH,
                  "element-loading-text": "Loading",
                  stripe: "",
                  "highlight-current-row": "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "昵称", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.is_black_child == 1
                            ? _c(
                                "el-link",
                                {
                                  staticClass: "cursor",
                                  staticStyle: {
                                    "text-decoration": "line-through",
                                  },
                                },
                                [
                                  _vm._v(
                                    "【" +
                                      _vm._s(scope.row.id) +
                                      "】" +
                                      _vm._s(scope.row.nick_name)
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.is_black_child == 0
                            ? _c("el-link", { staticClass: "cursor" }, [
                                _vm._v(
                                  "【" +
                                    _vm._s(scope.row.id) +
                                    "】" +
                                    _vm._s(scope.row.nick_name)
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.is_black_child == 1 &&
                          scope.row.black_reason
                            ? _c("div", { staticClass: "black-reason" }, [
                                _vm._v(
                                  "拉黑原因：" + _vm._s(scope.row.black_reason)
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "手机号码", width: "150" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm.checkRoles(_vm.config.system_other.have_role)
                            ? _c("div", [_vm._v(_vm._s(scope.row.mobile))])
                            : _c("div", [
                                _vm._v(_vm._s(_vm.dealPhone(scope.row.mobile))),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "充电桩用户", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                scope.row.is_zhuang_maxw == 0 ? "否" : "是"
                              ) +
                              "\n            "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "来源" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                scope.row.user_type == 0 ? "微信" : "支付宝"
                              ) +
                              "\n            "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _vm.checkRoles(["terminal", "partner"])
                  ? _c("el-table-column", {
                      attrs: { label: "已交押金" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.money || "--") +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        396875629
                      ),
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "租借次数" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n              " +
                              _vm._s(scope.row.used_num) +
                              "\n            "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _vm.agentInfo.virtual_divide == 0
                  ? _c("el-table-column", {
                      attrs: { label: "消费总金额", width: "120" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              ￥" +
                                    _vm._s(scope.row.paid_amount) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3099140759
                      ),
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.checkHidRole("agentPclbjexs")
                  ? _c("el-table-column", {
                      attrs: { label: "钱包余额" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.checkRoles(["partner"]) &&
                                _vm.checkHidRole("agent_ktxje")
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "text-blue cursor",
                                        on: {
                                          click: function ($event) {
                                            return _vm.$refs.editwith.showDialog(
                                              scope.row.id
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("￥" + _vm._s(scope.row.balance))]
                                    )
                                  : _c("a", [
                                      _vm._v("￥" + _vm._s(scope.row.balance)),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3692105875
                      ),
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.checkRoles(["terminal", "partner"])
                  ? _c("el-table-column", {
                      attrs: { label: "冻结金额" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              ￥" +
                                    _vm._s(scope.row.freez_balance) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3642341327
                      ),
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.checkRoles(["terminal", "partner"]) &&
                _vm.checkHidRole("prepaidcard")
                  ? _c("el-table-column", {
                      attrs: { label: "储值卡余额", width: "120" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              ￥" +
                                    _vm._s(scope.row.wash_balance) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        433787756
                      ),
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.checkRoles(["terminal", "partner"]) &&
                _vm.checkHidRole("prepaidcard")
                  ? _c("el-table-column", {
                      attrs: { label: "储值卡赠额", width: "120" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              ￥" +
                                    _vm._s(scope.row.wash_gift_balance) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1365418639
                      ),
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "最后登录时间", width: "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.parseTime(
                                  scope.row.upd_date,
                                  "{y}-{m}-{d} {h}:{i}"
                                )
                              ) +
                              "\n            "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "注册日期", width: "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.parseTime(
                                  scope.row.add_date,
                                  "{y}-{m}-{d} {h}:{i}"
                                )
                              ) +
                              "\n            "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _vm.checkRoles(["terminal", "partner"])
                  ? _c("el-table-column", {
                      attrs: { label: "操作", width: "200", fixed: "right" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.agentInfo.virtual_divide == 0 &&
                                _vm.agentInfo.check_order > 0
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "ml-0",
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          round: "",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.$router.push({
                                              path:
                                                "/userManage/user_order?search_uid=" +
                                                scope.row.id,
                                            })
                                          },
                                        },
                                      },
                                      [_vm._v("订单记录")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.checkRoles(["partner"])
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "ml-0",
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          round: "",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.memberDialog = true
                                            _vm.memberObj.uid = scope.row.id
                                          },
                                        },
                                      },
                                      [_vm._v("设置会员")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.checkRoles(["partner"])
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "ml-0",
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          round: "",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.recharge(scope.row, 1)
                                          },
                                        },
                                      },
                                      [_vm._v("余额充值")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.checkRoles(["partner"]) &&
                                _vm.checkHidRole("prepaidcard")
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "ml-0",
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          round: "",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.recharge(scope.row, 0)
                                          },
                                        },
                                      },
                                      [_vm._v("储值卡充值")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.checkRoles(["partner"]) &&
                                _vm.checkHidRole("prepaidcard")
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "ml-0",
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          round: "",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.recharge(scope.row, 2)
                                          },
                                        },
                                      },
                                      [_vm._v("储值卡赠值")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.checkRoles(["partner"])
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "ml-0",
                                        attrs: {
                                          type: "danger",
                                          size: "mini",
                                          round: "",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.refund(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("退款")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "ml-0",
                                    attrs: {
                                      type: "warning",
                                      size: "mini",
                                      round: "",
                                      plain: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showTradeLog(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("交易记录")]
                                ),
                                _vm._v(" "),
                                _vm.checkRoles(["partner"])
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "ml-0",
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          round: "",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.setBlack(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("黑名单")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        594222423
                      ),
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex justify-center" },
              [
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.listQuery.page_num > 0,
                      expression: "listQuery.page_num > 0",
                    },
                  ],
                  attrs: {
                    page: _vm.listQuery.start,
                    limit: _vm.listQuery.limit,
                    "page-count": _vm.listQuery.page_num,
                  },
                  on: {
                    "update:page": function ($event) {
                      return _vm.$set(_vm.listQuery, "start", $event)
                    },
                    "update:limit": function ($event) {
                      return _vm.$set(_vm.listQuery, "limit", $event)
                    },
                    pagination: _vm.getList,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "设置会员", visible: _vm.memberDialog },
          on: {
            "update:visible": function ($event) {
              _vm.memberDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "140px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "会员资格：" } },
                [
                  _c("el-switch", {
                    attrs: { "active-value": 1, "inactive-value": 0 },
                    model: {
                      value: _vm.memberObj.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.memberObj, "status", $$v)
                      },
                      expression: "memberObj.status",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "设备类型：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.memberObj.depend_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.memberObj, "depend_type", $$v)
                        },
                        expression: "memberObj.depend_type",
                      },
                    },
                    _vm._l(_vm.deviceKeyObj, function (item, key) {
                      return _c(
                        "el-radio-button",
                        { attrs: { label: key, disabled: key != 3 } },
                        [_vm._v(_vm._s(item))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "会员类型：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.memberObj.date_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.memberObj, "date_type", $$v)
                        },
                        expression: "memberObj.date_type",
                      },
                    },
                    _vm._l(_vm.config.cardObj, function (item) {
                      return _c(
                        "el-radio-button",
                        { attrs: { label: item.value } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商户ID：" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.memberObj.store_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.memberObj, "store_id", $$v)
                      },
                      expression: "memberObj.store_id",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.memberDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.setUserMember()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("editwith", { ref: "editwith", attrs: { type: 1 } }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "交易记录",
            visible: _vm.tradeLogDialogVisible,
            width: "900px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.tradeLogDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tradeLogLoading,
                  expression: "tradeLogLoading",
                },
              ],
            },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.tradeLogList, border: "", stripe: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "user_id", label: "用户ID", width: "100" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "关联订单ID", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-link",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.showOrderDetail(scope.row)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.order_id || "--"))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "交易时间", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.parseTime(
                                    scope.row.add_date,
                                    "{y}-{m}-{d} {h}:{i}:{s}"
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "交易金额", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                class:
                                  scope.row.change_type == 2
                                    ? "text-danger"
                                    : "text-success",
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      scope.row.change_type == 2 ? "-" : "+"
                                    ) +
                                    _vm._s(scope.row.change_money) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "赠送金额" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                "¥" + _vm._s(scope.row.send_money || "0.00")
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "余额" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                "¥ " +
                                  _vm._s(scope.row.current_balance || "0.00")
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "交易原因" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.change_reason || "--")),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tradeLogQuery.page_num > 0,
                    expression: "tradeLogQuery.page_num > 0",
                  },
                ],
                attrs: {
                  page: _vm.tradeLogQuery.start,
                  limit: _vm.tradeLogQuery.limit,
                  "page-count": _vm.tradeLogQuery.page_num,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.tradeLogQuery, "start", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.tradeLogQuery, "limit", $event)
                  },
                  pagination: _vm.getTradeLogList,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.tradeLogDialogVisible = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "订单详情", visible: _vm.orderDetailDialog },
          on: {
            "update:visible": function ($event) {
              _vm.orderDetailDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.orderDetailLoading,
                  expression: "orderDetailLoading",
                },
              ],
            },
            [
              _vm.checkRoles(["partner"]) && _vm.orderDetail.charging_power_min
                ? _c("span", [
                    _vm._v(
                      "使用功率范围：" +
                        _vm._s(_vm.orderDetail.charging_power_min) +
                        "-" +
                        _vm._s(_vm.orderDetail.charging_power_max)
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "el-timeline",
                _vm._l(_vm.orderDetail.operate_flow, function (item, index) {
                  return _c(
                    "el-timeline-item",
                    {
                      key: index,
                      attrs: { placement: "top", timestamp: item.date },
                    },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(item.event) + " ---> " + _vm._s(item.result)
                        ),
                      ]),
                      _vm._v(" "),
                      item.reason
                        ? _c(
                            "div",
                            { staticClass: "mt-5" },
                            [
                              _c("el-link", { attrs: { type: "danger" } }, [
                                _vm._v(_vm._s(item.reason)),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _vm.siteInfo.order_profits_detail_show == 1 ||
              _vm.checkRoles(_vm.config.system_other.have_role)
                ? [
                    _c("div", { staticClass: "flex mb-10 text-center" }, [
                      _c("div", { staticClass: "flex1" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex1" }, [
                        _vm._v(
                          "分成明细：" +
                            _vm._s(_vm.orderDetail.money_paid) +
                            " "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex1" }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex mb-10 text-center" }, [
                      _c(
                        "div",
                        {
                          staticClass: "flex2",
                          staticStyle: { width: "4rem", "text-align": "left" },
                        },
                        [_vm._v("分成人")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex1" }, [_vm._v("分成比例")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex1" }, [_vm._v("分成金额")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex1" }, [_vm._v("退款金额")]),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.orderDetail.agents_profit, function (item, key) {
                      return [
                        item.agent_level >= _vm.agentInfo.agent_level
                          ? _c(
                              "div",
                              { staticClass: "flex mb-10 text-center" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "flex2",
                                    staticStyle: {
                                      width: "4rem",
                                      "text-align": "left",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(item.agent_name) +
                                        "：" +
                                        _vm._s(item.parent_name)
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "flex1" }, [
                                  _vm._v(_vm._s(item.profit_percent)),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "flex1" }, [
                                  _vm._v(_vm._s(item.get_profit) + "元"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "flex1" }, [
                                  _vm._v(_vm._s(item.drawback_profit) + "元"),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }